import { RpcService } from 'rpc';
import { EssayData, CommentData } from '../interfaces';

export interface IDiscussionRpc extends RpcService {
	get_essays(params: { begin?: number; end?: number }): Promise<EssayData[]>;
	get_essay(params: { resultid?: string; quizid?: string }): Promise<EssayData>;
	get_replies(params: { resultid?: string; begin?: number; end?: number }): Promise<CommentData[]>;
	get_reply(params: { commentid?: string }): Promise<CommentData>;
	add_reply(params: { resultid?: string; reply?: string }): Promise<CommentData>;
}

export const svc: IDiscussionRpc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `@@discussion.rpc`,

	services: {
		get_essays: {
			parameters: [
				{ name: 'begin', type: 'integer', optional: true },
				{ name: 'end', type: 'integer', optional: true }
			]
		},
		get_essay: {
			parameters: [
				{ name: 'resultid', type: 'string', optional: true },
				{ name: 'quizid', type: 'string', optional: true }
			]
		},
		get_replies: {
			parameters: [
				{ name: 'resultid', type: 'string', optional: true },
				{ name: 'begin', type: 'integer', optional: true },
				{ name: 'end', type: 'integer', optional: true }
			]
		},
		get_reply: {
			parameters: [{ name: 'commentid', type: 'string', optional: true }]
		},
		add_reply: {
			parameters: [
				{ name: 'resultid', type: 'string', optional: true },
				{ name: 'reply', type: 'string', optional: true }
			]
		}
	}
}) as IDiscussionRpc;

export default svc;
